export default __webpack_public_path__ + "static/media/Karen.8d6dac89.JPG";